module.exports = {
      id: "unlock-usage",
      viewBox: "0 0 31.96 27.836",
      url: "img/" + "sprite.svg#unlock-usage",
      toString: function () {
        return this.url;
      }
    }